import React, { Component } from 'react';


const MethodBadge = props => {
  const {method, style, href, ...rest} = props;
  if(href) {
    return <a href={href} className="btn btn-default badge" {...rest}>{method}</a>;
  } else {
    return <span className="btn btn-default badge" {...rest}>{method}</span>;
  }
};

export default MethodBadge;
